export const environment = {
  production: true,
  version: '1.0.0',
  /** 后端 API 地址（生产环境） */
  apiBaseUrl: 'https://teacher.yzjblog.cn/api',
  /** 前端访问地址（用于生成分享二维码/链接） */
  frontendBaseUrl: 'https://teacher.yzjblog.cn',
  /** 生产恒关：禁止 dev mock 逻辑（拦截器不注册、service.enabled=false） */
  redeemQuoteMock: false,
};
